'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styling = require('@rexlabs/styling');

var _coreDecorators = require('core-decorators');

var _reactRedux = require('react-redux');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultStyles = (0, _styling.StyleSheet)({
  container: {
    borderRadius: 2,
    margin: 3,
    background: 'darkgrey',
    color: 'white',
    boxShadow: '0 2px 7px rgba(0, 0, 0, .1)',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    overflow: 'hidden'
  },

  // Padding on inner container to allow maxHeight animation
  // for leave and enter
  inner: {
    padding: 10
  },

  action: {
    color: 'white',
    textDecoration: 'underline'
  },

  closeButton: {
    border: '0 none',
    background: 'transparent',
    color: 'white',
    marginLeft: 6,
    fontSize: 16
  }
});

var Toast = (_dec = (0, _reactRedux.connect)(), _dec2 = (0, _styling.styled)(defaultStyles), _dec(_class = _dec2(_class = (0, _coreDecorators.autobind)(_class = function (_PureComponent) {
  (0, _inherits3.default)(Toast, _PureComponent);

  function Toast() {
    (0, _classCallCheck3.default)(this, Toast);
    return (0, _possibleConstructorReturn3.default)(this, (Toast.__proto__ || (0, _getPrototypeOf2.default)(Toast)).apply(this, arguments));
  }

  (0, _createClass3.default)(Toast, [{
    key: 'handleActionClick',
    value: function handleActionClick() {
      var _props = this.props,
          dispatch = _props.dispatch,
          action = _props.action;

      dispatch(action.reduxAction);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          text = _props2.text,
          isClosable = _props2.isClosable,
          action = _props2.action,
          s = _props2.styles,
          hide = _props2.hide,
          eventHandlers = _props2.eventHandlers;

      return _react2.default.createElement(
        'div',
        (0, _extends3.default)({}, s('container'), eventHandlers),
        _react2.default.createElement(
          'div',
          s('inner'),
          text,
          action && action.label && action.reduxAction && _react2.default.createElement(
            'div',
            (0, _extends3.default)({}, s('action'), { onClick: this.handleClick }),
            action.label
          ),
          isClosable && _react2.default.createElement(
            'button',
            (0, _extends3.default)({}, s('closeButton'), { onClick: hide }),
            '\xD7'
          )
        )
      );
    }
  }]);
  return Toast;
}(_react.PureComponent)) || _class) || _class) || _class);
exports.default = Toast;